import React, { useLayoutEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Cada página monta seu próprio AppLayout, então a sidebar é remontada a cada
// navegação e perderia a posição da rolagem.
const SCROLL_POSITION_KEY = 'sidebar_scroll_top';

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
    const location = useLocation();
    const { can } = useAuth();
    const asideRef = useRef(null);

    const menuGroups = [
        {
            items: [
                {
                    id: 'dashboard',
                    label: 'Dashboard',
                    path: '/dashboard',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                    ),
                },
            ],
        },
        {
            title: 'Produção',
            items: [
                {
                    id: 'production-orders',
                    label: 'Ordens de Produção',
                    path: '/production/orders',
                    module: 'Orders',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    ),
                },
                {
                    id: 'products',
                    label: 'Produtos',
                    path: '/production/products',
                    module: 'Products',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                    ),
                },
                {
                    id: 'supplies',
                    label: 'Insumos',
                    path: '/production/supplies',
                    module: 'Supplies',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                    ),
                },
                {
                    id: 'resources',
                    label: 'Recursos',
                    path: '/production/resources',
                    module: 'Resources',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    ),
                },
            ],
        },
        {
            title: 'Vendas',
            items: [
                {
                    id: 'sales',
                    label: 'Pedidos',
                    path: '/sales',
                    module: 'Sales',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17h6m-6-4h6m-6-4h6M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                    ),
                },
                {
                    id: 'clients',
                    label: 'Clientes',
                    path: '/settings/clients',
                    module: 'Clients',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                    ),
                },
            ],
        },
        {
            title: 'Cadastros',
            items: [
                {
                    id: 'warehouses',
                    label: 'Depósitos',
                    path: '/settings/warehouses',
                    module: 'Warehouses',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7l9-4 9 4M3 7v10l9 4 9-4V7M3 7l9 4 9-4M12 11v10" />
                        </svg>
                    ),
                },
                {
                    id: 'product-lines',
                    label: 'Linhas',
                    path: '/production/lines',
                    module: 'Products',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                    ),
                },
                {
                    id: 'client-types',
                    label: 'Tipos de cliente',
                    path: '/settings/client-types',
                    module: 'Clients',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                    ),
                },
                {
                    id: 'movement-types',
                    label: 'Tipos de movimento',
                    path: '/settings/movement-types',
                    module: 'MovementTypes',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12M8 12h12m-12 5h12M4 7h0m0 5h0m0 5h0" />
                        </svg>
                    ),
                },
            ],
        },
        {
            title: 'Relatórios',
            items: [
                {
                    id: 'report-min-max',
                    label: 'Mínimo máximo reposição',
                    path: '/reports/min-max-restock',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                    ),
                },
                {
                    id: 'report-projected-stock',
                    label: 'Saldo Atual e Projetado',
                    path: '/reports/projected-stock',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7l9-4 9 4M3 7v10l9 4 9-4V7M3 7l9 4 9-4M12 11v10" />
                        </svg>
                    ),
                },
                {
                    id: 'report-annual-stock',
                    label: 'Estoque anual',
                    path: '/reports/annual-stock',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    ),
                },
                {
                    id: 'report-stock-movements',
                    label: 'Movimentação de estoque',
                    path: '/reports/stock-movements',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                    ),
                },
                {
                    id: 'report-production-order-reports',
                    label: 'Registros de OP',
                    path: '/reports/production-order-reports',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                        </svg>
                    ),
                },
                {
                    id: 'report-sale-fulfillment',
                    label: 'Atendimento de pedidos',
                    path: '/reports/sale-fulfillment',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                        </svg>
                    ),
                },
                {
                    id: 'report-sale-backlog',
                    label: 'Carteira de pedidos',
                    path: '/reports/sale-backlog',
                    module: 'Reports',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7H4a1 1 0 00-1 1v10a2 2 0 002 2h14a2 2 0 002-2V8a1 1 0 00-1-1zM9 7V5a2 2 0 012-2h2a2 2 0 012 2v2M3 12h18" />
                        </svg>
                    ),
                },
            ],
        },
        {
            title: 'Configurações',
            items: [
                {
                    id: 'usuarios',
                    label: 'Usuários',
                    path: '/settings/user',
                    module: 'User',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                    ),
                },
                {
                    id: 'roles',
                    label: 'Perfis',
                    path: '/settings/roles',
                    module: 'Roles',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4 2 2 0 000 4zm0 0v2m0-2a2 2 0 110-4m6 4a2 2 0 100-4 2 2 0 000 4zm0 0v2m0-2a2 2 0 110-4m6 4a2 2 0 100-4 2 2 0 000 4zm0 0v2m0-2a2 2 0 110-4" />
                        </svg>
                    ),
                },
                {
                    id: 'tenant',
                    label: 'Empresa',
                    path: '/settings/tenant',
                    module: 'Tenant',
                    icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    ),
                },
            ],
        },
    ];

    const visibleMenuGroups = menuGroups
        .map((group) => ({
            ...group,
            items: group.items.filter((item) => !item.module || can(item.module)),
        }))
        .filter((group) => group.items.length > 0);

    // As permissões chegam depois do primeiro render: enquanto o menu cresce,
    // a posição salva ainda não cabe na altura rolável.
    const visibleItemCount = visibleMenuGroups.reduce((total, group) => total + group.items.length, 0);

    useLayoutEffect(() => {
        const aside = asideRef.current;
        if (!aside) return undefined;

        aside.scrollTop = Number(sessionStorage.getItem(SCROLL_POSITION_KEY)) || 0;

        const saveScroll = () => sessionStorage.setItem(SCROLL_POSITION_KEY, String(aside.scrollTop));
        aside.addEventListener('scroll', saveScroll, { passive: true });

        return () => aside.removeEventListener('scroll', saveScroll);
    }, [visibleItemCount]);

    const isActive = (path) => {
        if (!path) return false;
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    const handleLinkClick = () => {
        // Close sidebar on mobile when a link is clicked
        if (window.innerWidth < 768) {
            toggleSidebar();
        }
    };

    return (
        <>
            {/* Backdrop - visible only on mobile when sidebar is open */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-[55] md:hidden top-16"
                    onClick={toggleSidebar}
                    aria-hidden="true"
                />
            )}

            {/* Sidebar */}
            <aside
                ref={asideRef}
                className={`w-[280px] bg-white fixed left-0 top-16 bottom-0 z-[60] overflow-y-auto border-r border-gray-200 shadow-[6px_0_20px_-4px_rgba(15,23,42,0.14),2px_0_8px_-2px_rgba(15,23,42,0.06)] transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                    } md:translate-x-0`}
            >
                <nav className="p-3">
                    <div className="space-y-4">
                        {visibleMenuGroups.map((group, groupIndex) => (
                            <div key={`group-${groupIndex}`}>
                                {group.title && (
                                    <h3 className="px-4 mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                        {group.title}
                                    </h3>
                                )}
                                <div className="space-y-1">
                                    {group.items.map((item) => (
                                        <Link
                                            key={item.id}
                                            to={item.path}
                                            onClick={handleLinkClick}
                                            className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${isActive(item.path)
                                                    ? 'bg-primary-50 text-primary-600'
                                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                                }`}
                                        >
                                            {item.icon}
                                            <span className="text-sm font-medium">{item.label}</span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;

